import React from "react"
import { Route, Redirect } from "react-router-dom"

const legacyRoutesRedirects = [

	<Route
		key="attendant"
		exact
		path="/admin/attendant"
		render={() => <Redirect to="/admin/attendance/attendant" />}
	/>,

	<Route
		key="quick-reply"
		exact
		path="/admin/quick-reply"
		render={() => <Redirect to="/admin/attendance/quick-reply" />}
	/>,

	<Route
		key="teams"
		exact
		path="/admin/teams"
		render={() => <Redirect to="/admin/attendance/teams" />}
	/>,

	<Route
		key="templates"
		exact
		path="/admin/templates"
		render={() => <Redirect to="/admin/attendance/templates" />}
	/>,

	<Route
		key="client-catalog"
		exact
		path="/admin/client-catalog"
		render={() => <Redirect to="/admin/contacts/client-catalog" />}
	/>,

	<Route
		key="import-contacts"
		exact
		path="/admin/client-catalog/import-contacts"
		render={() => <Redirect to="/admin/contacts/import-contacts" />}
	/>,

	<Route
		key="tags"
		exact
		path="/admin/tags"
		render={() => <Redirect to="/admin/contacts/tags" />}
	/>,

	<Route
		key="smart-conversions"
		exact
		path="/admin/smart-conversions"
		render={() => (
			<Redirect to="/admin/conversion/trackable-links/smart-conversions" />
		)}
	/>,

	<Route
		key="trackable-links"
		exact
		path="/admin/tools/trackable-links"
		render={() => <Redirect to="/admin/conversion/tools/trackable-links" />}
	/>,

	<Route
		key="trackable-links-create"
		exact
		path="/admin/tools/trackable-links/create"
		render={() => (
			<Redirect to="/admin/conversion/tools/trackable-links/create" />
		)}
	/>,

	<Route
		key="trackable-links-edit"
		exact
		path="/admin/tools/trackable-links/:trackableLinkId/edit"
		render={({ match }) => (
			<Redirect
				to={`/admin/conversion/tools/trackable-links/${match.params.trackableLinkId}/edit`}
			/>
		)}
	/>,

	<Route
		key="trackable-links-details"
		exact
		path="/admin/tools/trackable-links/:trackableLinkId/details"
		render={({ match }) => (
			<Redirect
				to={`/admin/conversion/tools/trackable-links/${match.params.trackableLinkId}/details`}
			/>
		)}
	/>,

	<Route
		key="integration"
		exact
		path="/admin/integration"
		render={() => <Redirect to="/admin/automation/integration" />}
	/>,

	<Route
		key="integration-id"
		exact
		path="/admin/integration/:integrationId"
		render={({ match }) => (
			<Redirect
				to={`/admin/automation/integration/${match.params.integrationId}`}
			/>
		)}
	/>,

	<Route
		key="message-blast"
		exact
		path="/admin/message-blast"
		render={() => <Redirect to="/admin/automation/message-blast" />}
	/>,

	<Route
		key="message-blast-id"
		exact
		path="/admin/message-blast/:messageBlastId"
		render={({ match }) => (
			<Redirect
				to={`/admin/automation/message-blast/${match.params.messageBlastId}`}
			/>
		)}
	/>,

	<Route
		key="flow"
		exact
		path="/admin/flow"
		render={() => <Redirect to="/admin/automation/flow" />}
	/>,

	<Route
		key="flow-id"
		exact
		path="/admin/flow/:chatBotFlowId"
		render={({ match }) => (
			<Redirect
				to={`/admin/automation/flow/${match.params.chatBotFlowId}`}
			/>
		)}
	/>,

	<Route
		key="security"
		exact
		path="/admin/security"
		render={() => <Redirect to="/admin/account/security" />}
	/>,
	<Route
		key="funnel"
		exact
		path="/admin/funnel"
		render={() => <Redirect to="/admin/conversion/funnel" />}
	/>,

	<Route
		key="playground"
		exact
		path="/admin/playground"
		render={() => <Redirect to="/admin/ai/playground" />}
	/>,

	<Route
		key="agent"
		exact
		path="/admin/agent"
		render={() => <Redirect to="/admin/ai/agent" />}
	/>,

	<Route
		key="partnerships"
		exact
		path="/admin/partnerships"
		render={() => <Redirect to="/admin/results/partnerships" />}
	/>,

	<Route
		key="profile"
		exact
		path="/admin/profile"
		render={() => <Redirect to="/admin/account/profile" />}
	/>,

	<Route
		key="signature"
		exact
		path="/admin/signture"
		render={() => <Redirect to="/admin/account/signature" />}
	/>,

	<Route
		key="security"
		exact
		path="/admin/security"
		render={() => <Redirect to="/admin/account/security" />}
	/>
]

export default legacyRoutesRedirects
